import Vue from "vue";
import Vuex from "vuex";
import pathify from "vuex-pathify";

import userInfo from "./userInfo";
import globalAlert from "./alert";
import guestInfo from "./guestInfo";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [pathify.plugin],
  modules: {
    userInfo,
    globalAlert,
    guestInfo
  }
});
